/**
 * Global card token for consistent UI card styling across the landing page
 */
export const cardBase =
  "rounded-2xl border border-slate-300/80 bg-white shadow-[0_18px_30px_rgba(15,23,42,0.08)]";
